module.exports = __webpack_public_path__ + "img/ayan-nag-hut.1ca0d46.jpg";